
// Add Developers Profile
export const ADD_COMPLIANCE = 'ADD_COMPLIANCE';
export const ADD_COMPLIANCE_SUCCESS = 'ADD_COMPLIANCE_SUCCESS';
export const ADD_COMPLIANCE_FAIL = "ADD_COMPLIANCE_FAIL";